const SubnaticaPage = () => {
  return (
    <div>SubnaticaPage</div>
  )
}

export default SubnaticaPage